/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/jsx-no-bind */
import {
  Button,
  Col,
  ComboBox,
  Container,
  Controller,
  type IItem,
  InputNumber,
  Row,
  type TFormMethods,
  useFieldArray,
} from "@fluidattacks/design";
import { Fragment, useCallback } from "react";
import { useTranslation } from "react-i18next";

import type { IPolicyCriteria } from "../../../types";

interface IDualArrayFieldProps
  extends Pick<
    TFormMethods<IPolicyCriteria>,
    "control" | "setValue" | "watch" | "register"
  > {
  addText?: string;
  disabled?: boolean;
  max: number;
  min: number;
  placeholder?: string;
  required?: boolean;
  options: IItem[];
}
export const ArrayFields = ({
  disabled = false,
  required,
  max,
  min,
  placeholder,
  register,
  options,
  control,
  setValue,
  watch,
}: Readonly<IDualArrayFieldProps>): JSX.Element => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "criteria",
  });
  const { t } = useTranslation();

  const addItem = useCallback((): void => {
    append({ policy: "", value: 0 });
  }, [append]);

  const removeItem = useCallback(
    (index: number): (() => void) =>
      (): void => {
        remove(index);
      },
    [remove],
  );

  return (
    <Fragment>
      {fields.map((fieldProp, index) => (
        <Row align={"start"} key={fieldProp.id}>
          <Container alignItems={"start"} display={"inline-flex"} gap={0.5}>
            <Col lg={50} md={50} sm={50}>
              <Controller
                control={control}
                name={`criteria.${index}.policy`}
                render={({ field }) => (
                  <ComboBox
                    control={control}
                    items={options}
                    label={t(
                      "organization.tabs.policies.priority.modal.criterion",
                    )}
                    name={field.name}
                    placeholder={placeholder}
                    value={field.value}
                  />
                )}
              />
            </Col>
            <Col lg={35} md={35} sm={35}>
              <Controller
                control={control}
                key={fieldProp.id}
                name={`criteria.${index}.value`}
                render={({ field, fieldState }) => (
                  <InputNumber
                    error={fieldState.error?.message}
                    label={t(
                      "organization.tabs.policies.priority.modal.priorityValue",
                    )}
                    max={max}
                    min={min}
                    name={field.name}
                    register={register}
                    required={required}
                    setValue={setValue}
                    value={field.value}
                    watch={watch}
                  />
                )}
              />
            </Col>

            <Col lg={15} md={15} sm={15}>
              <Container
                alignItems={"center"}
                display={"flex"}
                gap={0.5}
                justify={"space-between"}
                mt={1.75}
              >
                {index > 0 && (
                  <Button
                    icon={"trash"}
                    onClick={removeItem(index)}
                    variant={"ghost"}
                    width={"50px"}
                  />
                )}
                {index < max - 1 && index + 1 === fields.length && (
                  <Button
                    disabled={disabled}
                    icon={"plus"}
                    onClick={addItem}
                    variant={"primary"}
                    width={"35px"}
                  />
                )}
              </Container>
            </Col>
          </Container>
        </Row>
      ))}
    </Fragment>
  );
};
